import React from 'react'
import arrayDestructure from '../Asset/portfolio/arrayDestructure.png'
import nodeInstall from '../Asset/portfolio/nodeInstall.jpg'
import reactParallax from '../Asset/portfolio/reactParallax.jpg'
import  reactWeather from '../Asset/portfolio/reactWeather.jpg'
import reactSmooth from '../Asset/portfolio/reactSmooth.png'
 
const Portfolio = () => {
  
        const protfolios = [
          {
              id : 1,
              src : arrayDestructure,
          },
          {
              id : 2,
              src : nodeInstall,
          },
          {
              id : 3,
              src : reactParallax,
          },
          {
              id : 4,
              src : reactWeather,
          },
          {
              id : 1,
              src : reactSmooth,
          },
        ]

  return (
    <div name="Portfolio" className='bg-gradient-to-b from-black to-gray-800 w-full text-white md:h-screen'>
         <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full' >
             <div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 border-gray-500'>Portfolio</p>
                <p className='py-6'>check out some of my work right here</p>
             </div>
             <div className='grid sm:gird-cols-2 md:grid-cols-3 px-12 sm:px-0 gap-8 '>

               {
                protfolios.map(({id,src})=>(

                  <div key={id} className='shadow-md shadow-gray-600 rounded-lg '>
                  <img  src={src} 
                  alt=""
                  className='rounded-md hover:scale-105 duration-200'
                  />
                  <div className='flex items-center justify-center'>
                      <button className='w-1/2 px-6 py-3 m-4 hover:scale-105 duration-200'>Demo</button>
                      <button className='w-1/2 px-6 py-3 m-4 hover:scale-105 duration-200'>Code</button>
                  </div>
              </div>

                ))
               }


             </div>
         </div>
    </div>
  )
}

export default Portfolio


//You can add feature of onlclick and go to another page where you have your code and demos